import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useRef, isValidElement } from 'react';
import styled from 'styled-components';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Fade } from '../Fade/Fade.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Backdrop = styled(Box).withConfig({
  componentId: "h2beog-0"
})(["top:0;left:0;bottom:0;right:0;display:flex;justify-content:center;align-content:center;width:100%;height:100vh;max-width:100vw;max-height:100%;max-height:100dvh;background-color:", ";"], palette("neutral.1000", 0.8));
var Content = styled(Box).withConfig({
  componentId: "h2beog-1"
})(["display:flex;flex-direction:column;justify-content:center;align-content:center;margin:0 auto;height:100%;overflow:hidden;"]);

var OverlayComponent = function OverlayComponent(_a) {
  var _b = _a,
      children = _b.children,
      _b$isVisible = _b.isVisible,
      isVisible = _b$isVisible === void 0 ? false : _b$isVisible,
      onClick = _b.onClick,
      _b$position = _b.position,
      position = _b$position === void 0 ? "fixed" : _b$position,
      _b$zIndex = _b.zIndex,
      zIndex = _b$zIndex === void 0 ? "overlay" : _b$zIndex,
      _b$timeout = _b.timeout,
      timeout = _b$timeout === void 0 ? 300 : _b$timeout,
      _b$transitionComponen = _b.transitionComponent,
      TransitionComponent = _b$transitionComponen === void 0 ? Fade : _b$transitionComponen,
      sx = _b.sx,
      props = __objRest(_b, ["children", "isVisible", "onClick", "position", "zIndex", "timeout", "transitionComponent", "sx"]);

  var backdropElement = useRef(null);

  var handleBackdropClick = function handleBackdropClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var clickWasOnBackdrop = backdropElement && backdropElement.current === e.target;

    if (clickWasOnBackdrop) {
      onClick == null ? void 0 : onClick(e);
    }
  };

  return (
    /* @__PURE__ */
    React.createElement(TransitionComponent, {
      in: isVisible,
      timeout: timeout,
      appear: true,
      mountOnEnter: true,
      unmountOnExit: true
    },
    /* @__PURE__ */
    React.createElement(Backdrop, {
      ref: backdropElement,
      onClick: handleBackdropClick,
      position: position,
      zIndex: zIndex,
      sx: sx
    },
    /*#__PURE__*/
    isValidElement(children) &&
    /* @__PURE__ */
    React.createElement(Content, __spreadValues({}, props), children)))
  );
};

var Overlay = maestroComponent("Overlay", OverlayComponent);
export { Overlay };